import React from "react"
import { Link } from "react-router-dom"

export default function Component() {
    const restaurants = [
      { name: "The Rustic Spoon", manager: "Emily Johnson" },
      { name: "Sizzle & Spice", manager: "Michael Chen" },
      { name: "Ocean's Bounty", manager: "Sarah Thompson" },
      { name: "Green Leaf Cafe", manager: "David Rodriguez" },
      { name: "Pasta Paradise", manager: "Sophia Rossi" },
      { name: "Smokey BBQ Joint", manager: "James Wilson" },
    ]
  
    return (
      <div className="min-h-screen bg-amber-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">Our Restaurants and Managers</h1>
          <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Restaurant Managers</h1>
<Link to="/manager_signup">
  <button className="flex items-center bg-black border text-white border-gray-300 rounded-full px-4 py-2 shadow-sm hover:bg-gray-100">
    Add New Manager
  </button>
</Link>

        </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {restaurants.map((restaurant, index) => (
              <div key={index} className="bg-gradient-to-r from-amber-400 to-amber-500 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-gray-900 mb-2">{restaurant.name}</h2>
                  <div className="flex items-center">
                    <svg className="h-6 w-6 text-gray-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                    <p className="text-white">Manager: {restaurant.manager}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      </div>
    )
  }